/**
 * FullStacked Cloud - Pure helpers for the auth-host passkey registration page.
 */

export function readTicket(hash: string): string | null {
    const ticket = new URLSearchParams(hash.replace(/^#/, "")).get("ticket");
    return ticket && ticket.startsWith("fsc_pkr_") ? ticket : null;
}

/** The opener is the Console; only notify FullStacked Cloud (or local development) origins. */
export function openerOrigin(referrer: string): string | null {
    try {
        const origin = new URL(referrer).origin;
        const host = new URL(origin).hostname;
        const trusted =
            (origin.startsWith("https://") && host.endsWith(".fullstacked.cloud")) ||
            host === "localhost" ||
            host === "127.0.0.1";
        return trusted ? origin : null;
    } catch {
        return null;
    }
}
